import { render, staticRenderFns } from "./hotelCateList.vue?vue&type=template&id=272bc1b8&scoped=true&"
import script from "./hotelCateList.vue?vue&type=script&lang=js&"
export * from "./hotelCateList.vue?vue&type=script&lang=js&"
import style0 from "./hotelCateList.vue?vue&type=style&index=0&id=272bc1b8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272bc1b8",
  null
  
)

export default component.exports